export default function PHP_expm1() {
  return (
    <div>
      <h1>PHP_expm1</h1>
    </div>
  );
}
